const {
	generalSettings,
	nodesConfig,
	sortOptions,
	themeConfig,
	customScripts,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

module.exports = function getSiteOptions() {
	const options = {};
	if (nodesConfig) {
		options.nodesConfig = nodesConfig;
	}
	if (sortOptions) {
		options.sortOptions = sortOptions;
	}
	if (themeConfig) {
		options.themeConfig = themeConfig;
	}
	if (customScripts) {
		options.customScripts = customScripts;
	}
	const drupalUrl = generalSettings.data.siteMetaData.drupalUrl || "";
	const match = drupalUrl.match(/:\/\/(.*?)-backend/);
	options.siteKey = match ? match[1] : "clf-demo";
	options.version = generalSettings.data.siteMetaData.version;
	options.globalSearch = {
		public: {
			hasDateRange: generalSettings.data.siteMetaData.hasSearchDateRange ? 1 : 0,
			hasDistance: generalSettings.data.siteMetaData.hasSearchDistance ? 1 : 0,
		},
	};
	return options;
};
